import React, { useState } from 'react';
import { signIn, signOut, resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import '../styles.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetStep, setResetStep] = useState(null); // null, 'email', 'code'
  const [resetEmail, setResetEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Clear any stale Amplify session to prevent
      // "There is already a signed in user" errors
      try { await signOut(); } catch (_) { /* no session to clear — fine */ }

      console.log('Attempting login with:', { username: email });
      await signIn({
        username: email,
        password,
      });
      console.log('Login successful');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      setError('Login failed: ' + error.message);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!resetEmail) {
      setError('Please enter your email.');
      return;
    }
    try {
      console.log('Sending password reset request for:', resetEmail);
      await resetPassword({ username: resetEmail });
      console.log('Reset code sent');
      setResetStep('code');
      setError('');
    } catch (error) {
      console.error('Reset password error:', error);
      setError('Failed to send reset code: ' + error.message);
    }
  };

  const handleResetConfirm = async (e) => {
    e.preventDefault();
    if (!resetCode || !newPassword) {
      setError('Please enter the code and new password.');
      return;
    }
    try {
      console.log('Confirming password reset for:', resetEmail);
      await confirmResetPassword({
        username: resetEmail,
        confirmationCode: resetCode,
        newPassword,
      });
      console.log('Password reset successful');
      setResetStep(null);
      setError('Password reset successful. Please log in with your new password.');
      setResetEmail('');
      setResetCode('');
      setNewPassword('');
    } catch (error) {
      console.error('Reset confirm error:', error);
      setError('Failed to reset password: ' + error.message);
    }
  };

  return (
    <div>
      <Navbar showSignUpButton={false} />
      <div className="auth-container">
        <div className="form-container">
          {resetStep === null && (
            <>
              <h2>Log in</h2>
              <form onSubmit={handleLogin}>
                <label htmlFor="login-email">Email</label>
                <input
                  type="email"
                  id="login-email"
                  name="login-email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="login-password">Password</label>
                <input
                  type="password"
                  id="login-password"
                  name="login-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button type="submit">Log in</button>
              </form>
              <p className="toggle-link">
                <a href="#" onClick={() => setResetStep('email')}>
                  Forgot Password?
                </a>
              </p>
              <p className="toggle-link">
                Don't have an account? <a href="/signup">Sign up</a>
              </p>
            </>
          )}
          {resetStep === 'email' && (
            <>
              <h2>Reset Password</h2>
              <p>Enter your email to receive a reset code.</p>
              <form onSubmit={handleForgotPassword}>
                <label htmlFor="reset-email">Email</label>
                <input
                  type="email"
                  id="reset-email"
                  name="reset-email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  required
                />
                <button type="submit">Send Reset Code</button>
              </form>
              <p className="toggle-link">
                <a href="#" onClick={() => setResetStep(null)}>
                  Back to Login
                </a>
              </p>
            </>
          )}
          {resetStep === 'code' && (
            <>
              <h2>Reset Password</h2>
              <p>Enter the code sent to {resetEmail} and your new password.</p>
              <form onSubmit={handleResetConfirm}>
                <label htmlFor="reset-code">Reset Code</label>
                <input
                  type="text"
                  id="reset-code"
                  name="reset-code"
                  value={resetCode}
                  onChange={(e) => setResetCode(e.target.value)}
                  required
                />
                <label htmlFor="new-password">New Password</label>
                <input
                  type="password"
                  id="new-password"
                  name="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <button type="submit">Reset Password</button>
              </form>
              <p className="toggle-link">
                <a href="#" onClick={() => setResetStep(null)}>
                  Back to Login
                </a>
              </p>
            </>
          )}
          {error && (
            <p style={{ color: error.includes('successful') ? 'green' : 'red', marginTop: '10px' }}>
              {error}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;